import { render } from "./QuickActionHost.vue?vue&type=template&id=2c0ade5c"
import script from "./QuickActionHost.vue?vue&type=script&lang=js"
export * from "./QuickActionHost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__